import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardPage',
})
export default class CmgLeaderboardPage extends Vue {


  async mounted() {
  }
}
